/*
  dm-cart-bridge.js
  -----------------
  Horizon's native "Add to cart" button (<add-to-cart-component>) adds the item
  and dispatches a bubbling 'cart:update' event, then expects the native
  <cart-drawer-component> to open. On this store the native drawer was replaced
  by the Dropmagic drawer (<dm-cart-drawer>), so nothing opened — the item only
  appeared after a page refresh.

  This bridge listens for the native 'cart:update' event, refreshes the
  Dropmagic drawer + cart-count bubble from the server, and opens the drawer.
*/
(function () {
  'use strict';

  var NATIVE_CART_EVENT = 'cart:update';
  var busy = false;

  function getDrawer() {
    return document.querySelector('dm-cart-drawer');
  }

  function onCartPage() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return window.location.pathname === cartUrl || window.location.pathname.indexOf(cartUrl + '/') === 0;
  }

  function replaceInner(html, fetchedSelector, liveSelector) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector(fetchedSelector);
    var live = document.querySelector(liveSelector);
    if (fresh && live) live.innerHTML = fresh.innerHTML;
  }

  function refreshAndOpen() {
    var drawer = getDrawer();
    if (!drawer || busy) return;
    busy = true;

    var base = window.location.pathname;

    Promise.all([
      fetch(base + '?section_id=dm-cart-drawer').then(function (r) { return r.text(); }),
      fetch(base + '?section_id=dm-cart-icon-bubble').then(function (r) { return r.text(); }).catch(function () { return ''; })
    ])
      .then(function (results) {
        // Refresh the drawer body (inner only, so the overlay + its close
        // handler from dm-cart.js stay intact)
        replaceInner(results[0], '.dm_drawer__inner', 'dm-cart-drawer .dm_drawer__inner');
        // Refresh the header cart-count bubble (section returns the inner fragment)
        replaceInner(results[1], '.shopify-section', '#dm-cart-count-bubble');

        // The drawer has items now, so clear any "empty" state
        var inner = drawer.querySelector('.dm_drawer__inner');
        if (inner) inner.classList.remove('dm-is-empty');
        drawer.classList.remove('dm-is-empty');

        // Open using the drawer's own method, with a CSS-class fallback
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        }
      })
      .catch(function (e) {
        console.error('[dm-cart-bridge] could not refresh/open the cart drawer:', e);
      })
      .finally(function () {
        busy = false;
      });
  }

  document.addEventListener(NATIVE_CART_EVENT, function (event) {
    // Ignore failed add operations
    if (event && event.detail && event.detail.data && event.detail.data.didError) return;
    // Don't hijack the cart page (quantity edits there shouldn't pop a drawer)
    if (onCartPage()) return;
    refreshAndOpen();
  });
})();
